import React, { Component } from 'react';
import PropTypes from 'prop-types';

class KioskSeriesHeaderContainer extends Component {
    render() {
        return(
            <div className="kiosk__series-picker__header">
                {this.props.children}
            </div>
        )
    }
}

export default KioskSeriesHeaderContainer